export default __webpack_public_path__ + "static/media/0x13748d548d95d78a3c83fe3f32604b4796cffa23.4ba3b19b.png";